import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const qrCodeService = {
    generate: async () => {
        try {
            const {data} = await axiosService.post(endPoints.qrCode.generate, {
                base_url: process.env.REACT_APP_URL
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    getPhotos: async (session_id) => {
        try {
            const {data} = await axiosService.get(endPoints.qrCode.generate, {
                params: {
                    session_id
                }
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    addPhotos: async (session_id, data) => {
        try {
            const res = await axiosService.put(endPoints.qrCode.generate, data, {
                params: {
                    session_id
                },
                headers: {
                    "Content-Type": 'multipart/form-data'
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    }
}

export {qrCodeService}
